import React from "react";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import LoadVipAccount from "Components/LoadVipAccount";
import BankList from "Components/BankList/BankList";
import { PRODUCTTYPES } from "Utils/Constants";
import useSession from "Utils/Hooks/useSession";

import "./MyAccounts.scss";

const MyAccounts = () => {
  const { session } = useSession();
  const productType = session?.patronProductType === PRODUCTTYPES.PREFERRED ? 'VIPP' : 'VIPO';

  const pageTitle = productType + " - My Accounts";
  document.title = pageTitle;
  //const title = (session.transactionSucceeded || fundType == FUNDTYPE.netspend) ? "My Funding Sources" : "My Bank Accounts"
  const title = "My Funding Sources"

  return (
    <>
      <Header />
      <div className="my-accounts">
        <div className="title text-center">{title}</div>
        <LoadVipAccount>
          <BankList />
        </LoadVipAccount>
      </div>
      <Footer />
    </>
  );
};

export default MyAccounts;